'use strict';

// https://262.ecma-international.org/6.0/#sec-algorithm-conventions

module.exports = require('math-intrinsics/max');



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2015/max.js
// module id = 788
// module chunks = 231608221292675